module.exports = __webpack_public_path__ + "pc/img/file_code.42cfc697.png";